// extracted by mini-css-extract-plugin
export default {"backGroundPicture":"gallery_backGroundPicture__fHJt-","h3":"gallery_h3__2qsCm"};